import { render, staticRenderFns } from "./CreateCourseModal.vue?vue&type=template&id=434fb886&scoped=true&"
import script from "./CreateCourseModal.vue?vue&type=script&lang=js&"
export * from "./CreateCourseModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434fb886",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/c/Users/wbreu/Documents/code/personal/the-unit-planner/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('434fb886', component.options)
    } else {
      api.reload('434fb886', component.options)
    }
    module.hot.accept("./CreateCourseModal.vue?vue&type=template&id=434fb886&scoped=true&", function () {
      api.rerender('434fb886', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/CreateCourseModal.vue"
export default component.exports